enum ExpenseType {
  Product = "product",
  Service = "service",
  Salary = "salary",
}

export default ExpenseType;
